import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design';
import './utils/index.less';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import "babel-polyfill"
import API from "./components/api/index"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

Vue.prototype.$API = API

Vue.use(Viewer)
Viewer.setDefaults({
  Options: { // Options必须，否则会出现默认打开等等不可预知的错误
    'inline': true,
    'button': true, // 显示右上角关闭按钮
    'navbar': true, // 缩略图导航
    'title': true, // 是否显示当前图片的标题
    'toolbar': true, // 显示工具栏
    'tooltip': true, // 显示缩放百分比
    'movable': true, // 图片是否可移动
    'zoomable': true, // 是否可缩放
    'rotatable': true, // 是否可旋转
    'scalable': true, // 是否可翻转
    'transition': true, // 是否使用 CSS3 过度
    'fullscreen': true, // 播放时是否全屏
    'keyboard': true, // 是否支持键盘
    'url': 'data-source' // 设置大图片的 url
  }
})

Vue.use(ViewUI);
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js